import { render, staticRenderFns } from "./SharedVariableTable.vue?vue&type=template&id=a48f511a&scoped=true"
import script from "./SharedVariableTable.vue?vue&type=script&lang=js"
export * from "./SharedVariableTable.vue?vue&type=script&lang=js"
import style0 from "./SharedVariableTable.vue?vue&type=style&index=0&id=a48f511a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48f511a",
  null
  
)

export default component.exports